import { render, staticRenderFns } from "./enable.vue?vue&type=template&id=67474a5c&"
import script from "./enable.vue?vue&type=script&lang=js&"
export * from "./enable.vue?vue&type=script&lang=js&"
import style0 from "./enable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports